var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H512V341.994H0V-0.00585938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H512V113.994H0V-0.00585938ZM0 227.994H512V341.994H0V227.994Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 210.994C278.591 210.994 296.5 193.086 296.5 170.994C296.5 148.903 278.591 130.994 256.5 130.994C234.409 130.994 216.5 148.903 216.5 170.994C216.5 193.086 234.409 210.994 256.5 210.994Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.5 133.494C235.789 133.494 219 150.283 219 170.994C219 191.705 235.789 208.494 256.5 208.494C277.211 208.494 294 191.705 294 170.994C294 150.283 277.211 133.494 256.5 133.494ZM214 170.994C214 147.522 233.028 128.494 256.5 128.494C279.972 128.494 299 147.522 299 170.994C299 194.466 279.972 213.494 256.5 213.494C233.028 213.494 214 194.466 214 170.994Z",
    fill: "#D6AB00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAr);
export default __webpack_public_path__ + "static/media/AR.a899ca315efb7f14e2da7e4e2db0c139.svg";
export { ForwardRef as ReactComponent };